import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';
import HomePage from '@/pages/HomePage';
import ProjectsPage from '@/pages/ProjectsPage';
import ActivitiesPage from '@/pages/ActivitiesPage';
import VideosPage from '@/pages/VideosPage';
import MapPage from '@/pages/MapPage';
import CalendarPage from '@/pages/CalendarPage';
import BlogPage from '@/pages/BlogPage';
import BlogPostPage from '@/pages/BlogPostPage';
import DonationsPage from '@/pages/DonationsPage';
import DonationsSuccessPage from '@/pages/DonationsSuccessPage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import MemberPage from '@/pages/MemberPage';
import AdminPage from '@/pages/AdminPage';
import AuthCallback from '@/components/AuthCallback';
import VisitorPage from '@/pages/VisitorPage';
import TrainingPage from '@/pages/TrainingPage';
import JobsPage from '@/pages/JobsPage';
import GalleryPage from '@/pages/GalleryPage';
import DocumentsPage from '@/pages/DocumentsPage';
import DocumentViewerPage from '@/pages/DocumentViewerPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import NewsPage from '@/pages/NewsPage';
import TestimonialsPage from '@/pages/TestimonialsPage';
import EmailRequestPage from '@/pages/EmailRequestPage';
import EmployeeWorkspacePage from '@/pages/EmployeeWorkspacePage';
import FormationsPage from '@/pages/FormationsPage';
import ChatWidget from '@/components/ChatWidget';
import VisitTracker from '@/components/VisitTracker';
import MaintenanceGate from '@/components/MaintenanceGate';
import LegalPage from '@/pages/LegalPage';

function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <VisitTracker />
      <MaintenanceGate>
      <Routes>
        <Route path="/" element={<HomePage />} />
      <Route path="/projets" element={<ProjectsPage />} />
      <Route path="/activites" element={<ActivitiesPage />} />
      <Route path="/videos" element={<VideosPage />} />
      <Route path="/carte" element={<MapPage />} />
      <Route path="/calendrier" element={<CalendarPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:id" element={<BlogPostPage />} />
      <Route path="/dons" element={<DonationsPage />} />
      <Route path="/dons/success" element={<DonationsSuccessPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/membre" element={<MemberPage />} />
      <Route path="/visiteur" element={<VisitorPage />} />
      <Route path="/formation" element={<FormationsPage />} />
      <Route path="/recrutement" element={<JobsPage />} />
      <Route path="/galerie" element={<GalleryPage />} />
      <Route path="/documents" element={<DocumentsPage />} />
      <Route path="/documents/view/:id" element={<DocumentViewerPage />} />
      <Route path="/a-propos" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/actualites" element={<NewsPage />} />
      <Route path="/temoignages" element={<TestimonialsPage />} />
      <Route path="/demande-email-cresa" element={<EmailRequestPage />} />
      <Route path="/espace-employe" element={<EmployeeWorkspacePage />} />
      <Route path="/formations" element={<FormationsPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/mentions-legales" element={<LegalPage />} />
      </Routes>
      </MaintenanceGate>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <ChatWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;
